import { render } from "./StudyShifts.vue?vue&type=template&id=53b42766"
import script from "./StudyShifts.vue?vue&type=script&lang=js"
export * from "./StudyShifts.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyShifts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b42766"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b42766', __exports__)) {
    api.reload('53b42766', __exports__)
  }
  
  module.hot.accept("./StudyShifts.vue?vue&type=template&id=53b42766", () => {
    api.rerender('53b42766', render)
  })

}


export default __exports__